import { render, staticRenderFns } from "./CommodityList.vue?vue&type=template&id=9d3021ce&scoped=true"
import script from "./CommodityList.vue?vue&type=script&lang=js"
export * from "./CommodityList.vue?vue&type=script&lang=js"
import style0 from "./CommodityList.vue?vue&type=style&index=0&id=9d3021ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3021ce",
  null
  
)

export default component.exports